<template lang="pug">
div
    Row(type="flex" justify="space-between")
        Col(:lg="2" :md="4" :sm="24" v-if="$store.getters.getDashboardConfig.dashboardWithSearchBtn")
            SearchChartBtn(searchBtnText="GO" searchBtnIcon="md-search")
        Col(:lg="22" :md="20" :sm="24")
            components(
                :is="dashboardQueryFilterStyle[$store.getters.getDashboardConfig.dashboardQueryFilter]"
                :isWithGroupName="true"
                :isWithServiceGroupName="true"
                :isWithAppProfileName="true"
                :isWithServerName="true"
                :isWithOrigin="currentTab !== 'report' "
                :isWithEdgeName="$store.getters.isAdmin && currentTab !== 'report'"
                :isWithLatencyStatusName="false"
                :customTimeRangeOptions="this.timeRangeOptions"
                :dateRangeLimit="this.dateRangeLimit"
            )
    Tabs(v-model="currentTab" :draggable="true" @on-drag-drop="handleDragDrop" @on-click="loadTimeSettings()")
        template(v-for="tab in tabList")
             TabPane(:label="tab.label" :name="tab.name")
                div(v-if="currentTab == tab.name && isShowDashBoard")
                    components(:is="tab.component")
</template>
<script>
import DashboardQueryFilterV2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilterV3 from "@/components/DashboardQueryFilterV3";

import { getTimeRangeOptions } from "@/libs/utils";

import RequestSummary from "./RequestSummary";
import Sampling from "./Sampling";
import Report from "./Report";
export default {
    components: {
        RequestSummary,
        Sampling,
        Report,
        SearchChartBtn: () => import("@/components/SearchChartBtn"),
    },
    data() {
        return {
            currentTab: "requestSummary",
            tabListMap: {
                requestSummary: {
                    label: "RequestSummary",
                    name: "requestSummary",
                    component: RequestSummary,
                },
                sampling: {
                    label: "Sampling",
                    name: "sampling",
                    component: Sampling,
                },
                report: {
                    label: "Report",
                    name: "report",
                    component: Report,
                },
            },
            tabList: [],
            dashboardQueryFilterStyle: {
                V2: DashboardQueryFilterV2,
                V3: DashboardQueryFilterV3,
            },
            timeRangeOptions: [],
            dateRangeLimit: 90,
            isShowDashBoard: true,
        };
    },
    methods: {
        formatTabList() {
            this.tabList = this.$store.state.dashboardTabList.map((tab) => {
                return this.tabListMap[tab];
            });
        },
        commitTabList() {
            return this.tabList.map((tab) => tab.name);
        },
        handleDragDrop(name, newName, a, b, names) {
            this.tabList.splice(b, 1, ...this.tabList.splice(a, 1, this.tabList[b]));
            this.$store.commit("SET_DASHBOARD_TAB_LIST", this.commitTabList());
        },
        async loadTimeSettings(tabName) {
            this.isShowDashBoard = false;
            const { dateRangeLimit, timeRangeOptions } = await getTimeRangeOptions({ dateRangeKey: this.currentTab });
            this.dateRangeLimit = dateRangeLimit;
            this.timeRangeOptions = timeRangeOptions;

            // 預設的時間選項會優先排在排序後的第一個位置
            const dateRangeOptionsValue = timeRangeOptions.map((item) => item.value).sort();
            // 未抓取到設定項目，預設提供1(過去一小時)
            const dateRangeOptionsIndex = dateRangeOptionsValue[0] || "1";

            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                key: "dateRangeOptions.index",
                value: dateRangeOptionsIndex,
            });
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "dateRangeOptions.customTimeRange", value: "" });

            this.$nextTick(() => {
                this.isShowDashBoard = true;
            });
        },
    },
    created() {
        this.formatTabList();
        this.loadTimeSettings();
    },
};
</script>



// WEBPACK FOOTER //
// src/view/dashboard/DashboardChart.vue